import { PropsWithChildren } from 'react';
import { MantineProvider } from '@mantine/core';
import { colorSchemeManager } from './colorScheme';
import { mantineTheme, resolver } from '.';

export const DesignSystemProvider = ({ children }: PropsWithChildren) => (
  <MantineProvider
    theme={mantineTheme}
    cssVariablesResolver={resolver}
    colorSchemeManager={colorSchemeManager}
    defaultColorScheme="auto"
  >
    {children}
  </MantineProvider>
);
